<template>
  <div>
    <el-dialog :visible.sync="show">
      <span slot="title">验收维修单</span>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label><b>单号:</b></label> {{ model.SN }}
          </div>
          <div class="form-group">
            <label><b>分类:</b></label> {{ model.CAT_NAME }}
          </div>
          <div class="form-group">
            <label><b>位置:</b></label> {{ model.LOC_NAME }}
          </div>
          <div class="form-group">
            <label><b>问题描述</b></label>
            {{ model.DESCRIPTION }}
          </div>
          <div class="form-group" v-if="model.ImageKvs">
            <el-image class="fiximg" v-for="item in model.ImageKvs" :src="item.Value" :key="item.Key"
              :preview-src-list="previewList">
            </el-image>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label><b>维修结果</b></label>
            <el-input type="textarea" :rows="2" v-model="model.MEM" />
          </div>
          <div class="form-group">
            <label><b>维修费用</b></label><br />
            <el-input-number v-model="model.COST" />
          </div>
          <div class="form-group">
            <label><b>维修照片</b></label>
            <div class="form-group" v-if="model.FinishImgKvs">
              <el-image class="fiximg" v-for="item in model.FinishImgKvs" :src="item.Value" :key="item.Key"
                :preview-src-list="previewList2">
              </el-image>
            </div>
          </div>
          <div class="form-group">
            <label><b>签名</b></label><img class="signImg" :src="model.MENDER_SIGN_PIC_URL" alt="">
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button icon="el-icon-close" @click="show = false">取消</el-button>
        <el-button icon="el-icon-time" type="warning" @click="submit(5)">备修中</el-button>
        <el-button icon="el-icon-check" type="success" @click="submit(8)">验收完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.fiximg {
  width: 100px;
  border: 1px solid #e8e8e8;
  margin-right: 5px;
  padding: 1px;
}
</style>
<script>
export default {
  data() {
    return {
      show: false,
      model: {},
      previewList: [],
      previewList2: []
    }
  },
  methods: {
    init(model) {
      this.show = true;
      this.model = JSON.parse((JSON.stringify(model)));
      if (this.model.ImageKvs)
        this.previewList = this.model.ImageKvs.map(x => x.Value);
      if (this.model.FinishImgKvs)
        this.previewList2 = this.model.FinishImgKvs.map(x => x.Value);
    },
    submit(sta) {
      let self = this;
      this.model.STA = sta;
      this.whale.remote.getResult({
        url: "/api/School/FIX/NoteApi/Confirmed",
        data: self.model,
        completed: function () {
          self.show = false;
          self.$emit("on-saved");
        }
      })
    }
  }
}
</script>